/*
 * Copyright © 2024. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import wizardStyle from "@/src/components/Form/wizardStyle";
import Grid from "@mui/material/Grid";
import { useForm } from "@/src/provider/Form/FormProvider";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import { translate } from "@/src/services/translations/translations";
import { requiredValidator } from "@/src/services/validationRules";
import Group from "@/src/components/Wizard/Group";
import CheckIcon from "@/src/assets/icons/common/toggleable/IconCheck";
import CrossIcon from "@/src/assets/icons/common/toggleable/IconClose";

export default function CreditRatingProblems() {
  const { values, errors } = useForm();
  const charCount = values.personalAffection?.creditRatingProblemsDescription?.length || 0;
  const descriptionHasError = (charCount > 0 && charCount < 50) || typeof errors["personalAffection.creditRatingProblemsDescription"] !== "undefined";

  return (
    <>
      <Grid sx={wizardStyle.gridTopSpaced} size={12}>
        <Grid size={12}>
          <Group
            type="radio"
            name="personalAffection.hadProblemsDueToCreditRating"
            question={translate("dataLeakContract.hadProblemsDueToCreditRating.question", values)}
            options={[
              {
                labelText: "Ja",
                labelIcon: <CheckIcon />,
                labelIconActive: <CheckIcon active />,
                value: "yes",
              },
              {
                labelText: "Nein",
                labelIcon: <CrossIcon />,
                labelIconActive: <CrossIcon active />,
                value: "no",
              },
            ]}
            validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
          />
        </Grid>
        {values.personalAffection.hadProblemsDueToCreditRating === "yes" && (
          <ValidatorTextField
            name="personalAffection.creditRatingProblemsDescription"
            label={translate("dataLeakContract.creditRatingProblemsDescription.label", values)}
            placeholder={translate("dataLeakContract.creditRatingProblemsDescription.placeholder", values)}
            InputLabelProps={{
              shrink: true,
            }}
            multiline
            rows={10}
            inputProps={{ minLength: 50, maxLength: 500 }}
            error={descriptionHasError}
            helperText={
              "[" + charCount + "/500] " + (descriptionHasError ? translate("dataLeakContract.creditRatingProblemsDescription.errors.tooShort", values) : "")
            }
            validators={[requiredValidator("Bitte geben Sie einen Text ein")]}
          />
        )}
      </Grid>
    </>
  );
}
